import { useEffect } from "react";
import {Link} from "react-router-dom";
import Table from "../table/Table";
import ErrorBoundary from "../common/ErrorBoundary";

type Props = {
	isSuperUser: boolean
}

const Dashboards = ({isSuperUser}: Props) => {


	useEffect(() => {
		document.title = "Dashboards - Smartocto";
		document.body.dataset.titleReady = "true";
	},[])


	return (
		<div className="container dashboards">
			<div className="row">
				<div className="col-md-12">
					<div className="dashboards__header">
						<h1>Dashboards</h1>
						<div className="dashboards__links">
							{/*<Link to="/user-management" className="btn btn-primary">*/}
							{/*    User management*/}
							{/*</Link>*/}
							{
								isSuperUser && (
									<Link to="admin/create-dashboard" className="btn btn-primary">
										Create dashboard
									</Link>
								)
							}
						</div>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-md-12">
					<ErrorBoundary>
					<Table isSuperUser={isSuperUser}/>
					</ErrorBoundary>
				</div>
			</div>
		</div>
	);
};

export default Dashboards;
